import Api, { configFormData } from "@/config/Api";

export default {
  // ─── Documents ────────────────────────────────────────────────────
  getDocumentsSummary() {
    return Api().get("/documents/summary");
  },

  getDocuments(options = {}) {
    return Api().get("/documents", options);
  },

  getDocument(id) {
    return Api().get(`/documents/${id}`);
  },

  createDocument(data) {
    return Api().post("/documents", data);
  },

  updateDocument(id, data) {
    return Api().put(`/documents/${id}`, data);
  },

  deleteDocument(id) {
    return Api().delete(`/documents/${id}`);
  },

  sendDocument(id, data = {}) {
    return Api().post(`/documents/${id}/send`, data);
  },

  linkQuote(id, quoteId) {
    return Api().post(`/documents/${id}/link-quote`, { quote_id: quoteId });
  },

  downloadDocument(id) {
    return Api().get(`/documents/${id}/download`, {
      responseType: "arraybuffer"
    });
  },

  duplicateDocument(id) {
    return Api().post(`/documents/${id}/duplicate`);
  },

  applyTextFields(id) {
    return Api().post(`/documents/${id}/apply-fields`);
  },

  signOwnerDocument(id, data) {
    return Api().post(`/documents/${id}/sign`, data);
  },

  signOwnerWithCertificate(id, formData) {
    return Api().post(`/documents/${id}/sign`, formData, configFormData);
  },

  cancelDocument(id, reason = null) {
    return Api().post(`/documents/${id}/cancel`, { reason });
  },

  archiveDocument(id) {
    return Api().post(`/documents/${id}/archive`);
  },

  validateDocument(id) {
    return Api().get(`/documents/${id}/validate`);
  },

  validateUploadedPdf(file) {
    const formData = new FormData();
    formData.append("file", file);
    return Api().post("/documents/validate", formData, configFormData);
  },

  validatePublicPdf(file) {
    const formData = new FormData();
    formData.append("file", file);
    return Api().post("/validate-document", formData, configFormData);
  },

  previewPdf(id, options = {}) {
    return Api().get(`/documents/${id}/preview-pdf`, {
      responseType: "arraybuffer",
      ...options
    });
  },

  // ─── Upload PDF ───────────────────────────────────────────────────
  uploadDocumentPdf(data) {
    const formData = new FormData();
    formData.append("file", data.file);
    formData.append("name", data.name);
    formData.append("type", data.type || "otro");
    formData.append("source", "upload");
    if (data.user_business_quote_id)
      formData.append("user_business_quote_id", data.user_business_quote_id);
    return Api().post("/documents", formData, configFormData);
  },

  // ─── Signers ──────────────────────────────────────────────────────
  getSigners(documentId) {
    return Api().get(`/documents/${documentId}/signers`);
  },

  addSigner(documentId, data) {
    return Api().post(`/documents/${documentId}/signers`, data);
  },

  updateSigner(signerId, data) {
    return Api().put(`/signers/${signerId}`, data);
  },

  deleteSigner(signerId) {
    return Api().delete(`/signers/${signerId}`);
  },

  reorderSigners(documentId, data) {
    return Api().post(`/documents/${documentId}/signers/reorder`, data);
  },

  // ─── Templates ────────────────────────────────────────────────────
  getTemplates(options = {}) {
    return Api().get("/document-templates", options);
  },

  getTemplate(id) {
    return Api().get(`/document-templates/${id}`);
  },

  createTemplate(data) {
    return Api().post("/document-templates", data);
  },

  // ─── Signing Certificates ────────────────────────────────────────
  getCertificates() {
    return Api().get("/signing-certificates");
  },

  uploadCertificate(data) {
    const formData = new FormData();
    formData.append("file", data.file);
    formData.append("password", data.password);
    if (data.name) formData.append("name", data.name);
    return Api().post("/signing-certificates", formData, configFormData);
  },

  deleteCertificate(id) {
    return Api().delete(`/signing-certificates/${id}`);
  },

  setDefaultCertificate(id) {
    return Api().post(`/signing-certificates/${id}/set-default`);
  },

  importSriCertificate() {
    return Api().post("/signing-certificates/import-sri");
  },

  // ─── Public Signing ──────────────────────────────────────────────
  getSigningDocument(token) {
    return Api().get(`/sign/${token}`);
  },

  getSigningPdf(token) {
    return Api().get(`/sign/${token}/pdf`, {
      responseType: "arraybuffer"
    });
  },

  submitSignature(token, data) {
    return Api().post(`/sign/${token}/sign`, data);
  },

  declineSignature(token, data) {
    return Api().post(`/sign/${token}/decline`, data);
  }
};
